module.exports = __webpack_public_path__ + "static/media/id.1c96f0c9.png";